import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { label: "Countdown", href: "#countdown" },
    { label: "Schedule", href: "#schedule" },
    { label: "Seating", href: "#tickets" },
    { label: "The Full 90", href: "#full90" },
    { label: "Teams", href: "#teams" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-black/95 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#" className="flex items-center gap-3">
          <img
            src="https://storage.readdy-site.link/project_files/ae39c9fb-c0ef-4d19-8b6a-d8adfd2c0a75/32693301-2181-40e9-bc79-b81cbb3228bc_n17thelaneclearWHITE.png?v=e21d2ac9cf8100cfbee6280d62f5a398"
            alt="N17 The Lane Logo"
            className="h-12 w-auto object-contain"
          />
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-white/80 hover:text-white text-sm font-medium tracking-wide uppercase transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#full90"
          className="hidden md:inline-flex items-center gap-2 bg-[#e8c34a] text-black text-sm font-bold px-5 py-2.5 rounded-full uppercase tracking-wider hover:bg-[#f0d060] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-beer-line text-base"></i>
          The Full 90 — $30
        </a>

        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-black/98 px-6 pb-6 pt-2 flex flex-col gap-4">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/80 hover:text-white text-sm font-medium tracking-wide uppercase transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#full90"
            onClick={() => setMenuOpen(false)}
            className="inline-flex items-center gap-2 bg-[#e8c34a] text-black text-sm font-bold px-5 py-2.5 rounded-full uppercase tracking-wider hover:bg-[#f0d060] transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            <i className="ri-beer-line text-base"></i>
            The Full 90 — $30
          </a>
        </div>
      )}
    </nav>
  );
}
